import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const certificateData = [
  // {
  //   id: 1,
  //   title: "Web Development Masterclass",
  //   issuer: "Tech Academy",
  //   date: "June 2023",
  //   image: "/images/certificate/certificate-01.webp",
  // },
  // {
  //   id: 2,
  //   title: "Advanced React Programming",
  //   issuer: "Code Institute",
  //   date: "September 2023",
  //   image: "/images/certificate/certificate-02.webp",
  // },
  {
    id: 3,
    title: "Advanced React Programming",
    issuer: "Code Institute",
    date: "September 2023",
    image: "/images/certificate/certificate-03.webp",
  },
  {
    id: 4,
    title: "Web Development Masterclass",
    issuer: "Tech Academy",
    date: "June 2023",
    image: "/images/certificate/certificate-04.webp",
  },
  {
    id: 5,
    title: "Advanced React Programming",
    issuer: "Code Institute",
    date: "September 2023",
    image: "/images/certificate/certificate-05.webp",
  },
  {
    id: 6,
    title: "Advanced React Programming",
    issuer: "Code Institute",
    date: "September 2023",
    image: "/images/certificate/certificate-06.webp",
  },
  {
    id: 7,
    title: "Advanced React Programming",
    issuer: "Code Institute",
    date: "September 2023",
    image: "/images/certificate/certificate-07.webp",
  },
];

const CertificateGridCard = () => {
  const [sliderRef, setSliderRef] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Functions to handle slider navigation
  const goToPrev = () => {
    if (sliderRef) {
      sliderRef.slickPrev();
    }
  };

  const goToNext = () => {
    if (sliderRef) {
      sliderRef.slickNext();
    }
  };

  return (
    <section className="ucwf-certificate py-5">
      <div className="container">
        <div className="position-relative">
          {/* Slider content */}
          <div className="certificate-slider-container">
            <Slider ref={(slider) => setSliderRef(slider)} {...settings}>
              {certificateData.map((certificate) => (
                <div key={certificate.id} className="px-3">
                  <div className="certificate-slide" style={{ height: "200px" }}>
                    <img
                      src={certificate.image}
                      alt={certificate.title}
                      className="ucwf-cert-img w-100 h-100 object-fit-contain"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* Navigation buttons positioned absolutely */}
          <div style={{ position: "absolute", width: "100%", top: "50%", transform: "translateY(-50%)", zIndex: 1, pointerEvents: "none" }}>
            <div className="d-flex justify-content-between px-4" style={{ pointerEvents: "none" }}>
              <button 
                className="certificate-prev-arrow" 
                onClick={goToPrev}
                style={{ 
                  border: "1px solid #ddd", 
                  borderRadius: "50%", 
                  width: "40px", 
                  height: "40px", 
                  background: "#fff",
                  cursor: "pointer",
                  pointerEvents: "auto"
                }}
              >
                ←
              </button>
              <button 
                className="certificate-next-arrow" 
                onClick={goToNext}
                style={{ 
                  border: "1px solid #ddd", 
                  borderRadius: "50%", 
                  width: "40px", 
                  height: "40px", 
                  background: "#fff",
                  cursor: "pointer",
                  pointerEvents: "auto"
                }}
              >
                →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificateGridCard;